/* ============================================================
   Lab Effects — SHARED PDP GALLERY
   assets/le-pdp-gallery.js

   THE one product-gallery engine. Extracted verbatim from
   assets/lab-pdp.js so the legacy single-source PDP and the merged
   tri-source PDP scroll, select and thumbnail identically.

   Contract — any [data-pdp-gallery] root containing:
     [data-gallery-slide]   one per image, first visible
     [data-gallery-thumb]   one per slide, click selects
     [data-gallery-dot]     optional progress dots
     [data-gallery-prev/next] optional arrows
     [data-thumbs-viewport] / [data-thumbs-track] the scrolling rail

   On the merged PDP slide 0 is the plant-source bottle and carries
   [data-bottle-img], so le-merged-pdp.js swaps its src when the
   source changes; every other slide is shared across sources.

   Load this BEFORE any script that depends on the gallery.
   ============================================================ */
(function () {
  function initGallery() {
    var galleries = document.querySelectorAll('[data-pdp-gallery]');
    galleries.forEach(function (gallery) {
      var slides = gallery.querySelectorAll('[data-gallery-slide]');
      if (slides.length <= 1) return;
      var dots = gallery.querySelectorAll('[data-gallery-dot]');
      var prevBtn = gallery.querySelector('[data-gallery-prev]');
      var nextBtn = gallery.querySelector('[data-gallery-next]');
      var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
      var viewport = gallery.querySelector('[data-thumbs-viewport]');
      var current = 0;
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      // Toggle the edge fades from the live scroll position (runs on manual
      // swipe/scroll too, not just on advance).
      function updateThumbFades() {
        if (!viewport) return;
        var maxScroll = viewport.scrollWidth - viewport.clientWidth;
        var x = viewport.scrollLeft;
        viewport.classList.toggle('has-left', x > 1);
        viewport.classList.toggle('has-right', maxScroll - x > 1);
      }

      // Scroll the native thumb rail so the active thumb sits at the left edge —
      // advancing by one rolls the leftmost thumb off and reveals the next on the
      // right, kept in sync with the main image. Free finger-swipe is handled by
      // the browser (overflow-x:auto); this just keeps the arrows/dots aligned.
      function updateThumbScroll() {
        if (!viewport || !thumbs.length) return;
        var maxScroll = viewport.scrollWidth - viewport.clientWidth;
        if (maxScroll > 0) {
          var activeEl = thumbs[current];
          var target = activeEl.offsetLeft;
          if (target < 0) target = 0;
          if (target > maxScroll) target = maxScroll;
          if (viewport.scrollTo) {
            viewport.scrollTo({ left: target, behavior: reduceMotion ? 'auto' : 'smooth' });
          } else {
            viewport.scrollLeft = target;
          }
        }
        updateThumbFades();
      }

      function showSlide(idx) {
        current = (idx + slides.length) % slides.length;
        slides.forEach(function (s, i) {
          s.style.display = i === current ? 'block' : 'none';
        });
        dots.forEach(function (d, i) {
          d.classList.toggle('le-pdp-stage__dot--active', i === current);
          d.style.width = i === current ? '22px' : '8px';
        });
        thumbs.forEach(function (t, i) {
          t.classList.toggle('le-pdp-thumb--active', i === current);
        });
        updateThumbScroll();
      }

      showSlide(0);
      if (prevBtn) prevBtn.addEventListener('click', function () { showSlide(current - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { showSlide(current + 1); });
      dots.forEach(function (dot, i) { dot.addEventListener('click', function () { showSlide(i); }); });
      thumbs.forEach(function (thumb, i) { thumb.addEventListener('click', function () { showSlide(i); }); });

      // Keep the edge fades honest while the user swipes/scrolls the rail by hand.
      if (viewport) viewport.addEventListener('scroll', updateThumbFades, { passive: true });

      // Recompute on resize (visible count changes) and once images/fonts settle
      // so the initial scroll position + fades are correct.
      var rzTimer;
      window.addEventListener('resize', function () {
        clearTimeout(rzTimer);
        rzTimer = setTimeout(updateThumbScroll, 150);
      });
      window.addEventListener('load', updateThumbScroll);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGallery);
  } else {
    initGallery();
  }
  window.LE_initGallery = initGallery;
})();
